/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, withTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/discussions';

import type { ForumPostWithCreator } from '../../__providers__/ForumPostDataProvider/__types__';

type Props = {
  post: ForumPostWithCreator;
  theme: Theme;
};

const AdminDetails = (props: Props) => {
  const { post } = props;
  return post.showAdminDetails ? (
    <span
      className="rc-forumsV2_AdminDetails"
      css={css`
        float: right;
      `}
    >
      <Typography2
        css={css`
          background-color: var(--cds-color-blue-25);
          border: 1px solid var(--cds-color-grey-50);
          border-radius: 3px;
          padding: var(--cds-spacing-50);
        `}
        component="span"
        variant="bodySecondary"
        aria-label={_t('Creator user ID')}
      >
        {_t('User ID: #{userId}', { userId: post.creator?.userId })}
      </Typography2>
    </span>
  ) : null;
};

export default withTheme(AdminDetails);
